export const setSize = (x, payload) =>
  self.resizeTo(payload.width, payload.height);
